module.exports = __webpack_public_path__ + "static/media/img3.3d34624d.png";